import EmailConfirmationView from './EmailConfirmationView';
import './EmailConfirmationView.scss';

export default EmailConfirmationView;
